<div class="mb-16">
  <h2 class="mb-4 text-lg tracking-wider text-primary-500 md:text-xl">
    {{ "impactReport.annualBudget.title" | transloco }}
  </h2>

  <!-- travel impact vs annual budget per person -->
  <div class="mb-2">
    <span class="md:text-md font-bold text-primary-500"
      >{{ "impactReport.annualBudget.travelImpact" | transloco }}
    </span>
    <span class="text-sm md:text-base"
      >{{ "impactReport.annualBudget.vs" | transloco }}
    </span>
    <span class="md:text-md font-bold text-alt-primary-100">{{
      "impactReport.annualBudget.annualBudgetPerPerson" | transloco
    }}</span>
  </div>

  <div class="mb-2 flex items-center">
    <app-custom-progress-bar
      [inputRatio]="ratio"
      [impactPerTraveller]="impactPerTraveller"
      class="h-8 flex-1 shrink md:h-12"
    />
    <div class="ml-2 font-bold text-primary-500 md:text-xl">
      {{ this.annualBudget }}%
    </div>
  </div>
  <p class="text-sm text-primary-500 md:text-base">
    {{ "impactReport.annualBudget.description" | transloco }}
  </p>
</div>
